export const ANIMATION_DURATION = 0.2;

export const TILE_TRANSITION = {
    duration: ANIMATION_DURATION,
    ease: 'easeOut',
} as const;

export const TILE_WIDTH_CSS_TRANSITION = `width ${ANIMATION_DURATION}s ease-out, min-width ${ANIMATION_DURATION}s ease-out`;

export const LARGE_SCREEN_BREAKPOINT = '(min-width: 1920px)';

export const MAIN_TILE_ID = '__main__';
